import { Skeleton, Stack } from "@mui/material";

export default function AttendedPageSkeleton() {
	return (
		<Stack gap="14px" padding="20px">
			<Stack
				direction="row"
				height="35px"
				justifyContent="space-between"
				alignItems="center"
				paddingBottom="20px"
				borderBottom="1px solid rgb(202,202,202)"
			>
				<Skeleton width="150px" />
				<Skeleton variant="rounded" width="135px" height="35px" />
			</Stack>
			<Stack direction="row" paddingTop="14px">
				{Array.from({ length: 4 }).map((_, idx) => (
					<Stack key={idx} width="100%" alignItems="center" gap="8px">
						<Skeleton variant="circular" width="100px" height="100px" />
						<Skeleton width="80px" />
					</Stack>
				))}
			</Stack>

			<Stack direction="row" gap="5px">
				<Skeleton variant="rounded" height="36px" width="135px" />
				<Skeleton variant="rounded" height="36px" width="180px" />
			</Stack>

			<Skeleton variant="rounded" height="500px" width="100%" />
		</Stack>
	);
}
